// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__XYQS7","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__olZd7"};